module.exports = __webpack_public_path__ + "img/vehicle_2.c2526ed8.png";